/* eslint-disable no-unused-vars */
import * as React from 'react';
import { styled } from '@linaria/react';
import { motion, AnimatePresence } from 'framer-motion';

import { range } from '@/utils';
import DefaultButton from '@/components/DefaultButton';

import { FRUITS } from './Fruits.data';

interface Props {
  numOfFruits: number;
  increment: () => void;
  decrement: () => void;
}

function FruitsArray({ numOfFruits, increment, decrement }: Props) {
  const [buttonsEnabled, setButtonsEnabled] = React.useState(true);

  function runTimer() {
    setButtonsEnabled(false);
    window.setTimeout(() => setButtonsEnabled(true), 200);
  }

  return (
    <Wrapper>
      <Actions>
        <ActionButton
          onClick={increment}
          disabled={numOfFruits === FRUITS.length}
        >
          Add Item
        </ActionButton>
        <ActionButton
          onClick={() => {
            decrement();
            runTimer();
          }}
          disabled={!buttonsEnabled || numOfFruits === 1}
        >
          Remove Item
        </ActionButton>
      </Actions>
      {'['}
      {/* NOTE: This doesn't work in dev mode because of Strict Mode. */}
      <AnimatePresence>
        {range(numOfFruits).map((i) => (
          <motion.span
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{
              opacity: 0,
              // NOTE: This throws a warning because “red” isn't
              // an animatable value, but I actually like the effect
              // of flipping to red instantly before disappearing
              color: 'red',
              transition: {
                duration: 0.2,
              },
            }}
            key={i}
          >{`  ${FRUITS[i]},`}</motion.span>
        ))}
      </AnimatePresence>
      {']'}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  white-space: pre-wrap;
  width: 250px;
  max-width: 80vw;
`;

const Actions = styled.span`
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
`;

const ActionButton = styled(DefaultButton)`
  flex: 1;
  font-size: 0.875rem;
`;

export default FruitsArray;
